import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import GlobalLoader from "../../common/GlobalLoader";
import InstitutionCourseCard from "../institutionCourseCard";
import EmptyPage from "../../common/emptyPage";
import "../../../styles/institution/overallCourses.scss";
import { getCourses } from "../../../helper/apicalls/course";
import Cookies from "js-cookie";

const BlogCourses = () => {
  const { setHeaderName, setIsShowSearch } = useOutletContext();
  const navigate = useNavigate();
  const location = useLocation();
  const role = Cookies.get("role");
  const portalBase =
    role === "admin"
      ? "/admin"
      : role == "teacher"
        ? "/teacher"
        : "/institution";
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCourses = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getCourses();
      const normalized = Array.isArray(data?.data)
        ? data.data
        : Array.isArray(data) && Array.isArray(data?.[0]?.course)
          ? data[0].course
          : Array.isArray(data)
            ? data
            : [];
      setCourses(normalized);
    } catch (err) {
      console.error("Failed to fetch institution courses for blog:", err);
      setError("Unable to load courses. Please try again.");
      setCourses([]);
    } finally {
      setLoading(false);
    }
  };

  const handleCourseClick = (course) => {
    if (!course || !course.key) return;
    navigate(
      `${portalBase}/blog/list?course=${encodeURIComponent(course.key)}`,
    );
  };

  useEffect(() => {
    setHeaderName && setHeaderName("Current Affairs - Courses");
    setIsShowSearch && setIsShowSearch(false);
    fetchCourses();
  }, []);

  return (
    <div className="overall-test-container">
      {loading && <GlobalLoader visible={loading} text="Loading courses..." />}

      {error && !loading && <EmptyPage content={error} />}

      {!error && Array.isArray(courses) && courses.length > 0 ? (
        <div className="overall-test-grid">
          {courses.map((course) => (
            <InstitutionCourseCard
              key={course.id || course.key || course.name}
              course={course}
              onClick={handleCourseClick}
              hideMenuIcon={true}
            />
          ))}
        </div>
      ) : (
        !error && !loading && <EmptyPage content={"No courses Available"} />
      )}
    </div>
  );
};

export default BlogCourses;
